import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
import { getScreenConfig } from "@/Redux/Ducks/entryFormSlice";
import { ControlTranslation } from "AlignComponents";
import { Card } from "react-bootstrap";
import { HiSparkles } from "react-icons/hi";
import { IoLinkSharp } from "react-icons/io5";

const FrequentlyUsed = () => {
  const dispatch = useAppDispatch();
  const frequentlyUsed = useAppSelector(x => x.Home.frequentlyUsed);

  const routeToObject = (objectcontrollerno: string) => {
    dispatch(getScreenConfig({ processCode: objectcontrollerno }))
  }

  return (
    <div className="widget user-frequent">
      <Card>
        <Card.Header>
          <Card.Title>
            <HiSparkles size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblfrequentlyused" />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="tiles">
            {
              frequentlyUsed.map(x => (
                <div className="tile" onClick={() => routeToObject(x.objectcontrollerno)}>
                  <IoLinkSharp size={28} />
                  {x.objectcontrollerstxt}
                </div>
              ))
            }
          </div>
        </Card.Body>
      </Card>
    </div >
  )
};

export default FrequentlyUsed;